export const descendingOrderSortFn = (a, b) => b.timestamp - a.timestamp;
